var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckHistoryPartnersDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 28.8C6 26.1491 8.14903 24 10.8 24H12C14.651 24 16.8 26.1491 16.8 28.8V38.4001C16.8 41.051 14.651 43.2001 12 43.2001H10.6681C8.09 43.2001 6 41.1101 6 38.5319C6 37.8692 6.53726 37.3319 7.2 37.3319C7.86274 37.3319 8.4 37.8692 8.4 38.5319C8.4 39.7846 9.41548 40.8 10.6681 40.8H12C13.3255 40.8 14.4 39.7255 14.4 38.4001V28.8C14.4 27.4746 13.3255 26.4 12 26.4H10.8C9.47452 26.4 8.4 27.4746 8.4 28.8V34.0761C8.4 34.7388 7.86274 35.2761 7.2 35.2761C6.53726 35.2761 6 34.7388 6 34.0761V28.8Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6 9.60005C18.6 6.94908 20.749 4.80005 23.4 4.80005H24.6C27.251 4.80005 29.4 6.94908 29.4 9.60005V38.4001C29.4 41.051 27.251 43.2001 24.6 43.2001H23.4C20.749 43.2001 18.6 41.051 18.6 38.4001V31.9099C18.6 31.84 18.606 31.7715 18.6174 31.705C18.606 31.6384 18.6 31.5699 18.6 31.5V9.60005ZM20.9826 31.705C20.994 31.7715 21 31.84 21 31.9099V38.4001C21 39.7255 22.0745 40.8 23.4 40.8H24.6C25.9255 40.8 27 39.7255 27 38.4001V9.60005C27 8.27457 25.9255 7.20005 24.6 7.20005H23.4C22.0745 7.20005 21 8.27457 21 9.60005V31.5C21 31.5699 20.994 31.6384 20.9826 31.705Z",
    fill: "#15D4B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2 19.2C31.2 16.5491 33.349 14.4 36 14.4H37.2C39.851 14.4 42 16.5491 42 19.2V38.4001C42 41.051 39.851 43.2001 37.2 43.2001H36C33.349 43.2001 31.2 41.051 31.2 38.4001V34.6006C31.2 34.5497 31.2032 34.4995 31.2093 34.4503C31.2032 34.4011 31.2 34.3509 31.2 34.3001V19.2ZM33.5907 34.4503C33.5968 34.4995 33.6 34.5497 33.6 34.6006V38.4001C33.6 39.7255 34.6745 40.8001 36 40.8001H37.2C38.5255 40.8001 39.6 39.7255 39.6 38.4001V19.2C39.6 17.8746 38.5255 16.8 37.2 16.8H36C34.6745 16.8 33.6 17.8746 33.6 19.2V34.3001C33.6 34.3509 33.5968 34.4011 33.5907 34.4503Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckHistoryPartnersDetails);
export default __webpack_public_path__ + "static/media/iconCheckHistoryPartnersDetails.b5928eeef4b29d88c57506d64049a136.svg";
export { ForwardRef as ReactComponent };